import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { TrendingUp, Mail, Lock, CheckCircle2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import api, { errMsg } from "@/lib/api";
import { SalesBackground } from "@/components/SalesBackground";

const Shell = ({ children, testId }) => (
  <div className="relative flex min-h-screen items-center justify-center p-6">
    <SalesBackground />
    <div className="card-premium relative z-10 w-full max-w-md p-10 fade-up" data-testid={testId}>
      <div className="mb-6 flex items-center gap-2.5">
        <div className="grid h-10 w-10 place-items-center rounded-xl bg-gradient-to-br from-[#1E3A8A] to-[#0F172A] text-white"><TrendingUp className="h-5 w-5" /></div>
        <p className="font-heading text-xl font-bold">JLY<span className="text-[#0284C7]">sales</span></p>
      </div>
      {children}
    </div>
  </div>
);

const Done = ({ text, testId }) => (
  <div className="text-center" data-testid={testId}>
    <CheckCircle2 className="mx-auto h-14 w-14 text-emerald-600" />
    <p className="mt-4 text-sm text-slate-600">{text}</p>
    <Link to="/login"><Button className="mt-6 w-full h-11" data-testid="back-to-login-btn">Kembali ke Login</Button></Link>
  </div>
);

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try { const { data } = await api.post("/auth/forgot-password", { email }); setDone(data.message); } catch (er) { setError(errMsg(er)); } finally { setBusy(false); }
  };
  return (
    <Shell testId="forgot-card">
      {done ? <Done text={done} testId="forgot-success" /> : (
        <form onSubmit={submit} data-testid="forgot-form">
          <p className="font-heading text-3xl font-bold">Lupa Password</p>
          <p className="mt-1 mb-6 text-sm text-slate-500">Masukkan email akun Anda. Kami akan mengirim link untuk membuat password baru.</p>
          <div className="relative mb-4">
            <Mail className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
            <Input className="h-11 pl-10 bg-white" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email-input" />
          </div>
          {error && <p className="mb-3 rounded-md bg-rose-50 p-2.5 text-sm text-rose-700" data-testid="forgot-error">{error}</p>}
          <Button type="submit" className="h-11 w-full" disabled={busy} data-testid="forgot-submit-btn">{busy ? "Mengirim..." : "Kirim Link Reset"}</Button>
          <p className="mt-6 text-center text-sm"><Link to="/login" className="font-semibold text-blue-800 hover:underline" data-testid="forgot-login-link">Kembali ke Login</Link></p>
        </form>
      )}
    </Shell>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const token = params.get("token") || "";
  const submit = async (e) => {
    e.preventDefault();
    if (pw !== confirm) return setError("Konfirmasi password tidak sama");
    setBusy(true);
    setError("");
    try { const { data } = await api.post("/auth/reset-password", { token, password: pw }); setDone(data.message); } catch (er) { setError(errMsg(er)); } finally { setBusy(false); }
  };
  return (
    <Shell testId="reset-card">
      {done ? <Done text={done} testId="reset-success" /> : !token ? (
        <p className="text-sm text-rose-700" data-testid="reset-missing-token">Link reset tidak valid. <Link to="/forgot-password" className="underline font-semibold">Minta link baru</Link></p>
      ) : (
        <form onSubmit={submit} data-testid="reset-form">
          <p className="font-heading text-3xl font-bold">Password Baru</p>
          <p className="mt-1 mb-6 text-sm text-slate-500">Buat password baru minimal 6 karakter.</p>
          <div className="space-y-3.5">
            <div className="relative"><Lock className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" /><Input className="h-11 pl-10 bg-white" type="password" placeholder="Password baru" value={pw} onChange={(e) => setPw(e.target.value)} required data-testid="reset-password-input" /></div>
            <div className="relative"><Lock className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" /><Input className="h-11 pl-10 bg-white" type="password" placeholder="Ulangi password baru" value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="reset-confirm-input" /></div>
            {error && <p className="rounded-md bg-rose-50 p-2.5 text-sm text-rose-700" data-testid="reset-error">{error}</p>}
            <Button type="submit" className="h-11 w-full" disabled={busy} data-testid="reset-submit-btn">{busy ? "Menyimpan..." : "Simpan Password Baru"}</Button>
          </div>
        </form>
      )}
    </Shell>
  );
}
